import React, { useEffect, useState } from "react";
import SelectForm from "../../Components/SelectForm/SelectForm";

import InputForm, {
  AutoCompleteValue,
} from "../../Components/InputForm/InputForm";
import BaseModal from "../../Components/BaseModel/BaseModel";
import { APICall } from "../../Helpers/Network/APICalls";
import {
  getConfigValues,
  //   insertUpdateNomineeIsAgreedTC,
  GetYojnaDepositDashboardDataByMemberId,
} from "../../Helpers/APIEndPoints/EndPoints";
import ButtonComponent from "../../Components/ButtonForm/Button";
import CustomModal from "../../Components/Modal/CustomModal";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import SanjeevaniTransaction from "./SanjeevaniTransaction";
import notify from "../../Helpers/ToastNotification";
import { AppModules } from "../../Helpers/Enums/AppModules";

const SanjeevaniForm = (props) => {
  const [data, setData] = useState({
    Name: "",
    terms: false,
    EmailId: "",
    TokenNo: "",
    AccountNumber: 0,
    BankName: "",
    BankNameId: 0,
    ContactNumber: 0,
    PANNo: "",
    IFSCCode: 0,
    Unit: "",
    MemberNumber: "",
  });
  const { appModule } = props;
  const [confirmMsg, setConfirmMsg] = useState("");
  const [discMsg, setDiscMsg] = useState("");
  const [amount, setAmount] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [termscondition, setTermscondition] = useState([]);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [modalOpen2, setModalOpen2] = React.useState(false);
  const [modalOpen3, setModalOpen3] = React.useState(true);
  const { showLoader, hideLoader } = React.useContext(LoaderContext);
  const [isTermsDisabled, setIsTermsDisabled] = useState(false);
  //   const { state } = useLocation();
  const location = useLocation();
  const YojnaType = location.state?.YojnaType || "SanjivaniYojna";
  let navigate = useNavigate();
  const context = getContext();
  const { state } = useLocation();
  const Id = state ? state.Id : null;
  let MemberId = context.MemberId;
  const { selectNextTab2, selectPreviousTab, disabled } = props;
  const [statusData, setStatusData] = React.useState(props?.statusData);
  const [displaySanjeevaniTransaction, setDisplaySanjeevaniTransaction] =
    useState(false);
  const isAdmin = context?.CurrentRoleId === RoleEnum.Admin;
  const isMember = context?.CurrentRoleId === RoleEnum.Member;
  // console.log("current appModule in sanjeevani form " + appModule);

  useEffect(() => {
    function fetchConfigValues() {
      ConfigValues();
      ConfigMsgs();
    }
    fetchConfigValues();
  }, []);

  useEffect(() => {
    async function fetchData() {
      await getDashboardData();
    }
    fetchData();
  }, [MemberId]);

  // get all fields data from backend
  const getDashboardData = async () => {
    showLoader();
    let obj = {
      MemberId: Id ? Id : MemberId,
      // YojnaType: YojnaType,
      YojnaType:
        appModule === AppModules.SuvidhaYojna
          ? "SuvidhaYojna"
          : "SanjivaniYojna",
    };
    const resp = await APICall(GetYojnaDepositDashboardDataByMemberId, obj);
    if (resp?.Data?.SNY_DepositList?.length > 0) {
      const SanjeevaniFormData = resp?.Data?.SNY_DepositList[0];
      setData({
        ...data,
        Name: SanjeevaniFormData.Name,
        EmailId: SanjeevaniFormData.EmailId,
        ContactNumber: SanjeevaniFormData.ContactNumber,
        BankName: SanjeevaniFormData.BankName,
        PANNo: SanjeevaniFormData.PANNo,
        TokenNo: SanjeevaniFormData.TokenNo,
        IFSCCode: SanjeevaniFormData.IFSCCode,
        AccountNumber: SanjeevaniFormData.AccountNumber,
        Unit: SanjeevaniFormData.Unit,
        MemberNumber: SanjeevaniFormData.MemberNumber,
      });
      // Here check the amount for popup message
      setAmount(SanjeevaniFormData.Amount);
    }
    hideLoader();
  };

  const onChange = (key, value) => {
    setData({ ...data, [key]: value });
  };

  // Disclaimer popup close
  const handleCloseModal = () => {
    isModalOpen == true ? setModalOpen(false) : setModalOpen(true);
  };

  const ConfigMsgs = async () => {
    let confirmationKey = "";
    let disclaimerKey = "";
    if (appModule === AppModules.SanjeevaniYojana) {
      confirmationKey = "SNJYConfirmationMessage";
      disclaimerKey = "SNJYDisclaimer";
    } else if (appModule === AppModules.SuvidhaYojna) {
      confirmationKey = "SUVYConfirmationMessage";
      disclaimerKey = "SUVYDisclaimer";
    }
    let param = `${getConfigValues}`;
    const getdata = await APICall(param, {
      Keys: [confirmationKey, disclaimerKey],
    });
    const confirmationMessage = getdata.Data?.find(
      (item) => item.Key === confirmationKey
    )?.Value;
    setConfirmMsg(confirmationMessage);

    const disclaimerMessage = getdata.Data?.find(
      (item) => item.Key === disclaimerKey
    )?.Value;
    setDiscMsg(disclaimerMessage);
  };

  //get getConfigValues for pop up and terms conditions
  const ConfigValues = async () => {
    let temp = [];
    let terms = [];
    if (appModule === AppModules.SanjeevaniYojana) {
      terms = ["terms1", "terms2", "SNJYConfirmationMessage", "SNJYSubmit"];
    } else if (appModule === AppModules.SuvidhaYojna) {
      terms = [
        "WebsiteName",
        "LoanAgreementMessageOne",
        "LoanAgreementMessageOne",
        "LoanModule_PendingWithInternalTeam",
        "SanjeevaniYojnaDescription",
        "SUVYConfirmationMessage",
        "fileExtentionSUV",
        "IsRenewalSanjeevaniModule",
        "terms1",
        "terms2",
        "SNJYConfirmationMessage",
        "SNJYSubmit",
      ];
    }

    let param = `${getConfigValues}`;
    const getdata = await APICall(param, { Keys: terms });
    temp = getdata?.Data?.map((c) => c?.Value);
    setTermscondition(temp);
    // console.log("terms and conditions", temp);
  };

  // Handle cross-browser compatibility
  const handleKeyNumbers = (event) => {
    const charCode = event.which || event.keyCode; // Handle cross-browser compatibility
    if (charCode >= 48 && charCode <= 57) {
      // Prevent numeric character input
      event.preventDefault();
    }
  };

  // confirm popup modal
  const handleCloseModal2 = () => {
    modalOpen2 == true ? setModalOpen2(false) : setModalOpen2(true);
  };

  // Confirm popup modal check amt
  const handleYesFunctionality = () => {
    if (
      (appModule === AppModules.SanjeevaniYojana && amount >= 300000) ||
      (appModule === AppModules.SuvidhaYojna && amount >= 50000)
    ) {
      setModalOpen2(false);
      setModalOpen3(true);
      // selectNextTab2();
    } else {
      setDisplaySanjeevaniTransaction(true);
    }
  };

  // Disclaimer popup navigate page
  const handleYesFunctionality3 = () => {
    navigate("/MemberDashboard");
    setModalOpen3(false);
  };

  const handleAmountChange = (event) => {
    let input = event.target.value;
    if (input.length > 30) {
      input = input.slice(0, 30);
    }
    const newAmount = input.replace(/[^0-9]/g, "");
    setAmount(newAmount);
  };

  const handleMemberNext = () => {
    if (isTermsAccepted) {
      ConfigMsgs();
      setModalOpen2(true);
    } else {
      notify(1, "Please accept the terms and conditions before proceeding.");
    }
  };

  const handleAdminNext = () => {
    // navigate("/SanjivaniTransaction");
    setDisplaySanjeevaniTransaction(true);
  };

  return (
    <div className="container-fluid">
      <>
        {displaySanjeevaniTransaction ? (
          <SanjeevaniTransaction
            selectNextTab={() => selectNextTab2(2)}
            appModule={appModule}
          />
        ) : (
          <>
            {(appModule === AppModules.SanjeevaniYojana &&
              amount >= 300000 &&
              isMember) ||
            (appModule === AppModules.SuvidhaYojna &&
              amount >= 50000 &&
              isMember) ? (
              <CustomModal
                show2={modalOpen3}
                handleClose2={() => setModalOpen3(false)}
                onHide2={() => setModalOpen3(false)}
                title="<h5>Disclaimer</h5>"
                body={`${discMsg}`}
                buttonLabel1="Home"
                handleYesFunctionality={handleYesFunctionality3}
                buttonLabel2={"close"}
                hideButton2={true} //Hide the 2nd button
              />
            ) : (
              <>
                <CustomModal
                  show2={modalOpen2}
                  handleClose2={handleCloseModal2}
                  onHide2={() => setModalOpen2(false)}
                  handleYesFunctionality={handleYesFunctionality}
                  title="<h5>ARE YOU SURE ?</h5>"
                  body={`<p>${confirmMsg}</p><b>Note : FD will be created on 1st day of next month.</b>`}
                  buttonLabel2="No"
                  buttonLabel1="Yes"
                  hideButton2={false}
                />
                <div className="row ">
                  {/* Member Id */}
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group ">
                      <label>Member ID</label>
                      <sup>*</sup>
                      <InputForm
                        placeholder={""}
                        value={data.MemberNumber}
                        onChange={(val: any) => {
                          let value = val.target.value;
                          onChange("memberID", value);
                        }}
                        isDisabled={true}
                        onKeyPress={handleKeyNumbers}
                      />
                    </div>
                  </div>

                  {/* Tocken No */}
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group ">
                      <label>Token No</label>
                      <InputForm
                        value={""}
                        placeholder={data.TokenNo}
                        isDisabled={true}
                        textArea={false}
                        onChange={"onSearchFilter"}
                      />
                    </div>
                  </div>

                  {/* Unit */}
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group ">
                      <label>Unit</label>
                      <InputForm
                        value={data.Unit}
                        placeholder={"Unit"}
                        isDisabled={true}
                        textArea={false}
                        onChange={"onSearchFilter"}
                      />
                      {/* {roleErrorDropdown && (
              <p className="text-danger">{roleErrorDropdown}</p>
            )} */}
                    </div>
                  </div>

                  {/* Name */}
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group ">
                      <label>Name</label>
                      <InputForm
                        value={data.Name}
                        placeholder={"Name"}
                        isDisabled={true}
                        textArea={false}
                        onChange={"onSearchFilter"}
                      />
                    </div>
                  </div>

                  {/* Email Id */}
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group ">
                      <label>Email Id</label>
                      <InputForm
                        placeholder={"Email Id"}
                        value={data.EmailId}
                        type="text"
                        isDisabled={true}
                      />
                    </div>
                  </div>

                  {/* Mobile No */}
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group ">
                      <label>Mobile No</label>
                      <InputForm
                        placeholder={"Mobile No"}
                        value={data.ContactNumber}
                        onChange={(val: any) => {
                          let value = val.target.value;
                        }}
                        isDisabled={true}
                        onKeyPress={handleKeyNumbers}
                      />
                    </div>
                  </div>

                  {/* Amount */}
                  {/* <div className="col-lg-4 col-sm-4 col-xs-4 ">
                        <div className="form-group ">
                          <label>Amount</label>
                          <sup>*</sup>
                          <InputForm
                            placeholder={"Amount"}
                            value={amount}
                            type="text"
                            isDisabled={false}
                            onChange={handleAmountChange}
                          />
                        </div>
                      </div> */}

                  {/* Bank Name */}
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group ">
                      <label>Bank Name</label>
                      <InputForm
                        placeholder={"Bank Name"}
                        value={data.BankName}
                        onChange={(val: any) => {
                          let value = val.target.value;
                          onChange("bankName", value);
                        }}
                        isDisabled={true}
                      />
                      {/* {error[data.guardianaddress] && (
              <p style={{ color: "red" }}>{error[data.guardianaddress]}</p>
            )} */}
                    </div>
                  </div>

                  {/* IFSC Code */}
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group ">
                      <label>IFSC Code</label>
                      <InputForm
                        placeholder={""}
                        value={data.IFSCCode}
                        onChange={(val: any) => {
                          let value = val.target.value;
                          onChange("ifsc", value);
                        }}
                        isDisabled={true}
                      />
                      {/* {error[data.guardianaddress] && (
              <p style={{ color: "red" }}>{error[data.guardianaddress]}</p>
            )} */}
                    </div>
                  </div>

                  {/* Account Number */}
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group ">
                      <label>Account Number</label>
                      <InputForm
                        placeholder={""}
                        maxlength={20}
                        value={data.AccountNumber}
                        type="number"
                        isDisabled={true}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>

                  {/* PAN No */}
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group ">
                      <label>PAN No</label>
                      <InputForm
                        placeholder={"PAN No"}
                        maxlength={10}
                        value={data.PANNo}
                        type="text"
                        isDisabled={true}
                      />
                    </div>
                  </div>

                  {/* Only for mrmber I agree to */}
                  <div className="col-lg-12 col-sm-12 col-xs-12 ">
                    {isMember && (
                      <>
                        <input
                          autoComplete={AutoCompleteValue}
                          placeholder={""}
                          value={""}
                          checked={isTermsAccepted}
                          onChange={(val: any) => {
                            let value = val.target.checked;
                            // onChange("terms", value);
                            setIsTermsAccepted(value);
                          }}
                          type="checkbox"
                          disabled={isTermsDisabled}
                        />
                        <span style={{ marginLeft: "12px" }}>
                          I agree to{" "}
                          <BaseModal
                            buttonText={"terms & conditions"}
                            open={isModalOpen}
                            content={
                              <ModalDesign
                                message={
                                  termscondition.length > 0 &&
                                  termscondition.map((d, index) => (
                                    <div>
                                      {index + 1}. {d}
                                    </div>
                                  ))
                                }
                                closefunc={handleCloseModal}
                              />
                            }
                            onclose={handleCloseModal}
                          />
                        </span>
                      </>
                    )}
                    {/*  */}
                    {/* {error["terms"] && <p style={{ color: "red" }}>{error["terms"]}</p>} */}
                  </div>
                </div>

                {isMember && (
                  <div className="d-flex justify-content-end">
                    {/* <ButtonComponent
                        icon={"fas fa-arrow-left"}
                        value={"Back"}
                        className="btn btn-primary btn-back"
                        onClick={() => {}}
                    /> */}

                    {/* Next */}
                    <ButtonComponent
                      icon={"fas fa-arrow-right"}
                      value={"Next"}
                      style={{ marginLeft: "10px" }}
                      id={"saveBtn"}
                      disabled={false}
                      onClick={handleMemberNext}
                    />
                  </div>
                )}

                {isAdmin && (
                  <div className="d-flex justify-content-end">
                    <ButtonComponent
                      icon={"far fa-hand-point-left"}
                      value={"Back"}
                      className="btn btn-primary btn-back"
                      onClick={() => {
                        const path =
                          appModule === AppModules.SanjeevaniYojana
                            ? "/SanjivaniDashboard"
                            : "/SuvidhaDashboard";
                        navigate(path);
                      }}
                    />
                    {/* Next */}
                    <ButtonComponent
                      icon={"fas fa-arrow-right"}
                      value={"Next"}
                      style={{ marginLeft: "10px" }}
                      id={"saveBtn"}
                      disabled={false}
                      onClick={handleAdminNext}
                    />
                  </div>
                )}
              </>
            )}
          </>
        )}
      </>
    </div>
  );
};

export default SanjeevaniForm;

const ModalDesign = ({ message, closefunc }) => {
  return (
    <>
      <div style={{ overflow: "auto", height: "250px" }}>
        <label
          className="d-block"
          style={{
            fontWeight: "bold",
            marginBottom: "10px",
            fontFamily: "var(--bs-body-font-family)",
            fontSize: "var(--bs-body-font-size)",
          }}
        >
          {"Terms & Conditions"}
        </label>
        {message}
      </div>
      <div className="row justify-content-end no-gutters">
        <div className="col-auto">
          <button onClick={closefunc} className="btn btn-submit btn-sm">
            OK
          </button>
        </div>
      </div>
    </>
  );
};
